/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowjustdoit4Inputs */

const en_aiflowjustdoit4 = /** @type {(inputs: Aiflowjustdoit4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just do it`)
};

const de_aiflowjustdoit4 = /** @type {(inputs: Aiflowjustdoit4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfach machen`)
};

/**
* | output |
* | --- |
* | "Just do it" |
*
* @param {Aiflowjustdoit4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowjustdoit4 = /** @type {((inputs?: Aiflowjustdoit4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowjustdoit4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowjustdoit4(inputs)
	return de_aiflowjustdoit4(inputs)
});
export { aiflowjustdoit4 as "aiFlowJustDoIt" }